import { Col, Row } from "antd";
import { matchPath, useHistory } from "react-router-dom";
import { FC } from "react";
import "./companyProfile.less";
import { IRoute, paths, Routes } from "@router";
import Tabs from "@components/Tabs";
import { tabs } from "./config";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { useTypedSelector } from "@/hooks";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useFetchCompaniesQuery } from "@services";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { ICompany } from "@/types";
import CompanySelectCarousel from "@components/caurosel";
import "../CompanyList/apps.less";

interface ICompanyProfile {
  routes: IRoute[];
}

const ClientCompanyProfile: FC<ICompanyProfile> = ({ routes }) => {
  const { user } = useTypedSelector(state => state.auth);
  const history = useHistory();
  const match = matchPath(window.location.pathname, {
    path: paths.client.users.companies.profile.business_units.regions,
  });
  const [
    page,
    // setPage
  ] = useState(1);
  const [searchString, setSearchString] = useState<string>("");
  const [isCompanySelected, setIsCompanySelected] = useState<boolean>(false);
  const [selectedCompany, setselectedCompany] = useState<ICompany>();

  const { data: companiesData, isLoading: isFetching } = useFetchCompaniesQuery(
    page,
    {
      skip: !user?.role?.includes("TOM"),
    }
  );
  const { data } = companiesData || {};

  const onPressNext = (company: any) => {
    setIsCompanySelected(true);
    history.push(`${paths.client.users.companies.listing}/${company?.id}`);
  };

  let handleCompanySelect = (company: ICompany) => {
    setselectedCompany(company);
    setSelectedCompanyInStorage(company);
    onPressNext(company);
  };

  if (
    !isCompanySelected &&
    user?.role === "TOM_MASTER_USER" &&
    !user?.company?.id
  ) {
    return (
      <div className="ApplicationSelector  w-full px-12">
        <h2 className="font-bold text-center text-6xl text-themeBlue mt-6 ">
          Select the Company
        </h2>

        {isFetching ? (
          <div className="flex justify-center items-center mt-28">
            <LoadingOutlined className="spinner" />
          </div>
        ) : (
          <CompanySelectCarousel
            onPress={handleCompanySelect}
            companiesList={data && data}
          />
        )}
      </div>
    );
  }
  return (
    <div>
      {checkPermission([
        permissions.VIEW_BUSINESS_UNIT,
        permissions.VIEW_REGION,
      ]) ? (
        <div className="companyProfile">
          {match ? null : (
            <>
              <Row>
                <Col span={24}>
                  <div className="main-heading mb-16"></div>
                </Col>
              </Row>
              <Tabs
                param=":company_id"
                route={true}
                paramValue={
                  user?.company?.id
                    ? `${user?.company?.id}`
                    : `${selectedCompany?.id}`
                }
                tabs={tabs}
              />
            </>
          )}
          <div className="companyProfile__content">
            <Routes routes={routes} />
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ClientCompanyProfile;
